import React from 'react';
import { Td, Tr, useDisclosure, AccordionPanel, Text } from '@chakra-ui/react';
import { localise, pluralise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import { optionalValue } from '../../../services/text/optionalValue';
import { getLocationPosition } from '../../../services/text/getLocationPosition';
import EditLocationModal from './EditLocation/EditLocationModal';
import LocationFindingsWrapper from '../FindingsWrapper/LocationFindingsWrapper';
import ExpandableTableRow from '../Table/ExpandableTableRow';
import TableRowEditButton from '../SurveyFindings/TableRowEditButton';
import { makeMed4 } from '../../../styles/textStyles';
import RenderIfElse from '../RenderIf/RenderIfElse';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import LocationFindingsShareWrapper from '../FindingsWrapper/Share/LocationFindingsShareWrapper';
import { UnsavedChangesProvider } from '../UnsavedChanges/UnsavedChangesProvider';
import TableAccordionButton from '../Table/TableAccordionButton';
const LocationFindingsTableRow = ({ data, isExpanded, canEdit, onLocationMutated, onRowClick, }) => {
    const { isShare } = useInspectionDetailContext();
    const tokens = useTokens();
    const editLocationModal = useDisclosure();
    const handleDetailsClick = (event) => {
        event.stopPropagation();
        editLocationModal.onOpen();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ExpandableTableRow, { isExpanded: isExpanded, "data-testid": "location-findings_table_row_row", onClick: onRowClick },
            React.createElement(TableAccordionButton, { isExpanded: isExpanded }),
            React.createElement(Td, { "data-testid": "location-findings_table_row__name" }, data.name),
            React.createElement(Td, { "data-testid": "location-findings_table_row__findings" }, `${data.findings_count} ${pluralise(localise('FINDING'), data.findings_count)}`),
            React.createElement(Td, { "data-testid": "location-findings_table_row__position" }, optionalValue(getLocationPosition(data))),
            React.createElement(Td, { "data-testid": "location-findings_table_row__dimensions" }, optionalValue(data.dimensions)),
            React.createElement(Td, { w: "115px", align: "right" },
                React.createElement(TableRowEditButton, { canEdit: canEdit, onClick: handleDetailsClick, "data-testid": "location-findings_table_row__details" },
                    React.createElement(Text, { sx: makeMed4(tokens) }, localise('DETAILS')))),
            React.createElement(UnsavedChangesProvider, null,
                React.createElement(EditLocationModal, { isOpen: editLocationModal.isOpen, onClose: editLocationModal.onClose, location: data, canEdit: canEdit, onSuccess: () => {
                        onLocationMutated?.();
                    }, onLocationMutated: onLocationMutated }))),
        React.createElement(AccordionPanel, { as: Tr, bgColor: tokens.Layer01, overflowY: "auto", overflowX: "hidden" },
            React.createElement(Td, { colSpan: 6 },
                React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(LocationFindingsShareWrapper, { isExpanded: isExpanded, location: data }), else: React.createElement(LocationFindingsWrapper, { isExpanded: isExpanded, location: data }) })))));
};
export default LocationFindingsTableRow;
